import React from 'react';

import { useMutation,useQuery } from "@apollo/client";
import {
  Select,
  MenuItem,
  Button,
  InputLabel,
  FormControl,
  TextField,
} from "@mui/material";
import { useState, useEffect } from "react";
import { toggleSnackbar, authVar } from "../../ReactiveVariables/index";
import { ADD_NOTES, UPDATE_ORDER_NOTE, DELETE_ORDER_NOTE, UPDATE_ORDER_STATUS, UPDATE_ORDER_HAS_DRIVER } from "../../Graphql/mutations";
import {GET_ONE_USER_INFO} from "../../Graphql/queries";
import moment from "moment";
import { CircularProgress } from "@mui/material";
import DialogBox from "../Common/dialogBox";
import { useNavigate } from "react-router-dom";
import { useReactiveVar } from "@apollo/client";
import { userDeatils } from "../../ReactiveVariables/index";
import { getUserType } from "@utils/user-format.utils";
import { PaymentProviderBadge } from "@components/molecules/payment-provider-badge";

export default function OrderStatus(props) {
  const orderStatus = props?.orderValues?.getOneOrder?.orderStatus;
  const driverStatus = props?.orderValues?.getOneOrder?.hasDriver;
  console.log(driverStatus)
  const [status, setStatus] = useState(orderStatus ?? "");
  const [hasDriver, setHasDriver] = useState(driverStatus ?? false);
  console.log('hasDriver', hasDriver, 'top')
  const [notes, SetNotes] = useState("");
  const navigate = useNavigate()
  const [errorMessage, setErrorMessage] = useState('')
  const [openDialog, setOpenDialog] = useState(false)
  const [editNoteId, setEditNoteId] = useState(null);
  const [editNoteText, setEditNoteText] = useState('');
  const [deleteNoteId, setDeleteNoteId] = useState(null);
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const currentDate = new Date();
  const sortArray = structuredClone(props?.orderValues?.getOneOrder?.orderNotes)
  const sortLog = structuredClone(props?.orderValues?.getOneOrder?.orderLog)

  const user = useReactiveVar(userDeatils);
  const userType = getUserType(user);
  
  // Check if this is a Stripe order (used only for showing payment provider badge)
  const isStripeOrder = props?.orderValues?.getOneOrder?.stripePaymentIntentId || 
                       props?.orderValues?.getOneOrder?.stripeCheckoutSessionId;
  
  // Check if this is an Authorize.net order (used only for showing payment provider badge)
  const isAuthorizeNetOrder = props?.orderValues?.getOneOrder?.transactionId && !isStripeOrder;
  
  const UserName=({ userId }) => {
    if (!userId || userId === "undefined") {
      return <span>No user ID provided</span>;
    }
    const { data, loading, error } = useQuery(GET_ONE_USER_INFO, {
      variables: { userId },
      skip: !userId || userId === "undefined"
    });
    if (loading) return <span>Loading...</span>;
    if (error) {
      console.error("Error fetching user:", error);
      return <span>Error fetching user: {error.message}</span>;
    }
    // Now access the correct key from the returned data
    return <span>{data.getOneUser?.name}</span>;
  }
  const [addNotes] = useMutation(ADD_NOTES, {
    refetchQueries: ['GetOneOrder'],
    onCompleted: () => { SetNotes(''); }
  });

  const [updateNote] = useMutation(UPDATE_ORDER_NOTE, {
    refetchQueries: ['GetOneOrder'],
    onCompleted: () => { setEditNoteId(null); setEditNoteText(''); }
  });

  const [deleteNote] = useMutation(DELETE_ORDER_NOTE, {
    refetchQueries: ['GetOneOrder'],
    onCompleted: () => setDeleteNoteId(null)
  });

  const [updateStatus, { loading: updateloading }] = useMutation(UPDATE_ORDER_STATUS, { refetchQueries: ['GetOneOrder'] });

  const [updateOrderHasDriver] = useMutation(UPDATE_ORDER_HAS_DRIVER, {
    refetchQueries: ['GetOneOrder'],
    onError: (error) => {
      console.error('Error updating driver status:', error);
      toggleSnackbar({
        status: true,
        message: 'Error updating driver status',
        variant: 'error'
      });

      // reset to original value if fails
      setHasDriver(driverStatus);
    },
    onCompleted: () => {
      toggleSnackbar({
        status: true,
        message: 'Driver status updated!',
        variant: 'success'
      });
    }
  });

  const handleStatus = (event) => {
    setStatus(event.target.value);
  };

  const handleHasDriver = (event) => {
    const newValue = event.target.value === 'true'; // Convert string value to boolean
    setHasDriver(newValue);

    updateHasDriver(newValue);
  };

  const handleNotes = (event) => {
    SetNotes(event.target.value);
    setErrorMessage('')
  };

  useEffect(() => {
    if (orderStatus) {
      setStatus(orderStatus)
    }
  }, [orderStatus]);

  useEffect(() => {
    if (driverStatus) {
      setHasDriver(driverStatus)
    }
  }, [driverStatus]);

  function onSubmit() {
    if (!notes) {
      setErrorMessage("Add a note")
      return
    }

    const trimmed = notes.trim();
    const ADJUSTMENT_REGEX = /^[^:]+:\s*([-+]?\d+(\.\d{1,2})?)$/;
    if (trimmed.includes(":") && !ADJUSTMENT_REGEX.test(trimmed)) {
      setErrorMessage('Invalid format. Use: "reason: amount" (e.g. "late delivery: -50")');
      return;
    }

    try {
      addNotes({ variables: { orderId: props?.id, note: notes } })
        .then((res) => {
          toggleSnackbar({
            status: true,
            message: "Note added successfully",
            variant: 'success'
          });
        })
        .catch((err) => {
          const message = err && err.message
          if (message === "Not authenticated") {
            localStorage.clear();
            authVar({
              loaded: true,
              auth: false,
            });
            navigate("/login", { state: "noAuth" })
          } else {
            toggleSnackbar({
              status: true,
              message: message,
              variant: "error",
            });
          }
        });
    } catch (err) {
      const message = err && err.message;
      toggleSnackbar({
        status: true,
        message: message,
        variant: "error",
      });
    }
  }

  function statusUpdate() {
    // "Completed-ACH" is a UI-only sentinel for closing out an order paid by
    // ACH / external payment (MAIN-822). It completes the order without hitting
    // Stripe by sending orderStatus "Completed" plus paymentMethod "ACH".
    const isAchCloseout = status === 'Completed-ACH';
    const effectiveStatus = isAchCloseout ? 'Completed' : status;

    // Show alert for Completed status (including ACH closeout)
    if (effectiveStatus === 'Completed') {
      window.alert('⚠️ Please wait while we generate the email receipt and PDF invoice. This may take a few moments.');
    }

    let data = {
      oldStatus: orderStatus,
      orderStatus: effectiveStatus,
      statusChangeDate: currentDate,
      statusTimeZone: timeZone,
      orderId: props?.id,
      _id: props?.id,
      ...(isAchCloseout ? { paymentMethod: 'ACH' } : {})
    };

    try {
      updateStatus({ variables: { data: data } })
        .then((res) => {
          const successMessage = effectiveStatus === 'Completed'
            ? "Order marked as completed! Email receipt and PDF invoice are being generated and sent to the customer."
            : "Status updated successfully";
          
          toggleSnackbar({
            status: true,
            message: successMessage,
            variant: 'success'
          });
        })
        .catch((err) => {
          const message = err && err.message
          if (message === "Not authenticated") {
            localStorage.clear();
            authVar({
              loaded: true,
              auth: false,
            });
            navigate("/login", { state: "noAuth" })
          } else {
            toggleSnackbar({
              status: true,
              message: message,
              variant: "error",
            });
          }
        });
    } catch (err) {
      const message = err && err.message;
      toggleSnackbar({
        status: true,
        message: message,
        variant: "error",
      });
    }
  }

  function updateHasDriver (newValue) {
    try {
      updateOrderHasDriver({
        variables: {
          hasDriver: newValue,
          orderId: props?.id
        }
      });
    } catch (error) {
      // Handle any errors if necessary
      console.error('Error updating driver status:', error);
      toggleSnackbar({
        status: true,
        message: 'Error updating driver status',
        variant: 'error'
      });
    }
  }

  console.log('hasDriver', hasDriver)

  return (
    <div className="order-status-wrap order-status-wrap-bottom">
      {openDialog && (<DialogBox
        setOpenDialog={setOpenDialog}
        handleDelete={statusUpdate}
        openDialog={openDialog}
        title={`${status === 'Completed-ACH' ? 'Close (ACH / External Payment)' : status} Order`}
        discription={`Are you sure you want mark this order as ${status === 'Completed-ACH' ? 'Completed (ACH / External Payment)' : status}?`}
        description2={
          (status === 'Completed' || status === 'Completed-ACH')
            ? '*Order amount would be settled to the bank account registered with us.\n\n⚠️ Please wait while we generate the email receipt and PDF invoice. This may take a few moments.'
            : null
        }
      />
      )}


      <div className="order-view-title">
        <h5 className="h5">Order Status</h5>
      </div>
      
      {/* Payment Provider Information */}
      {(isStripeOrder || isAuthorizeNetOrder) && (
        <div className="os-update" style={{ marginBottom: "16px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontWeight: 600, color: "#333" }}>Payment Method:</span>
            <PaymentProviderBadge order={props?.orderValues?.getOneOrder} showDetails={true} size="small" />
          </div>
        </div>
      )}
      
      <div className="order-status">
        <div className="os-update">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Order Status</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={status}
              label="Choose Status"
              onChange={handleStatus}
            >
              {orderStatus !== "Pending" || orderStatus !== "Declined" &&
                <MenuItem disabled={
                  orderStatus === "Cancelled" ||
                  orderStatus === "Completed" ||
                  orderStatus === "Scheduled" ||
                  orderStatus === "Pending" ||
                  orderStatus === "Approved"
                } value={'New'}>New</MenuItem>
              }

              {orderStatus !== "Pending" &&
                <MenuItem disabled={orderStatus === "Cancelled" || orderStatus === "Completed"} value={'Scheduled'}>Scheduled</MenuItem>
              }
              {orderStatus !== "Pending" &&
                <MenuItem disabled={orderStatus === "Cancelled"} value={'Completed'}>Completed</MenuItem>
              }
              {orderStatus !== "Pending" &&
                <MenuItem disabled={orderStatus === "Cancelled" || orderStatus === "Completed"} value={'Completed-ACH'}>Close (ACH / External Payment)</MenuItem>
              }
              {orderStatus === "Pending" &&
                <MenuItem disabled={orderStatus === "Pending" || orderStatus === "Approved"} value={'Pending'}>Pending</MenuItem>
              }
              {(orderStatus === "Pending" || orderStatus === "Approved") &&
                <MenuItem disabled={orderStatus === "Approved"} value={'Approved'}>Approved</MenuItem>
              }
              {(orderStatus === "Pending") &&
                <MenuItem disabled={orderStatus === "Declined"} value={'Declined'}>Declined</MenuItem>
              }
              {userType === "Admin" && (
                <MenuItem disabled={orderStatus === "Completed"} value={'Cancelled'}>Cancelled</MenuItem>
              )}
            </Select>
          </FormControl>

          <Button 
            onClick={() => setOpenDialog(true)} 
            variant="contained" 
            disabled={status === orderStatus || updateloading} 
            className="status-update-btn"
          >
            {updateloading ? <CircularProgress color="inherit" size={20} /> : "Update Order Status"}
          </Button>

        </div>
        <div className="os-update">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Driver Status</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={hasDriver ? 'true' : 'false'}
              label="Choose Driver Status"
              onChange={handleHasDriver}
            >
              <MenuItem value={'true'}>Driver Set</MenuItem>
              <MenuItem value={'false'}>No Driver</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div className="os-note">
          <h6 className="h6">Our Notes</h6>
          <TextField
            id="outlined-multiline-flexible"
            label="Input Text"
            multiline
            rows={4}
            value={notes}
            onChange={handleNotes}
            placeholder={'e.g. "late delivery: -50" or "bonus adjustment: +20"'}
            helperText="For adjustments use format: reason: amount (e.g. late delivery: -50)"
          />
          {errorMessage && <span className="error-msg">{errorMessage}</span>}
          <div className="text-end">
            <Button onClick={onSubmit} variant="contained" className="os-add-note-btn">Add</Button>
          </div>
        </div>

        <div className="os-notes-history">
          <h6 className="h6">Notes</h6>
          {deleteNoteId && (
            <DialogBox
              setOpenDialog={() => setDeleteNoteId(null)}
              handleDelete={() => deleteNote({ variables: { orderId: props?.id, noteId: deleteNoteId } })}
              openDialog="confirm"
              title="Delete Note"
              discription="Are you sure you want to delete this note?"
            />
          )}
          {sortArray && sortArray.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)).map((item) => (
            <div key={item?._id} className="os-notes-history-cnt">
              {editNoteId === item?._id ? (
                <>
                  <TextField
                    fullWidth
                    multiline
                    rows={2}
                    value={editNoteText}
                    onChange={(e) => setEditNoteText(e.target.value)}
                    size="small"
                  />
                  <div style={{ display: 'flex', gap: '8px', marginTop: '6px' }}>
                    <Button
                      size="small"
                      variant="contained"
                      onClick={() => {
                        const trimmedEdit = editNoteText.trim();
                        const ADJUSTMENT_REGEX = /^[^:]+:\s*([-+]?\d+(\.\d{1,2})?)$/;
                        if (trimmedEdit.includes(":") && !ADJUSTMENT_REGEX.test(trimmedEdit)) {
                          toggleSnackbar({ status: true, message: 'Invalid format. Use: "reason: amount" (e.g. "late delivery: -50")', variant: 'error' });
                          return;
                        }
                        updateNote({ variables: { orderId: props?.id, noteId: item._id, note: editNoteText } });
                      }}
                    >
                      Save
                    </Button>
                    <Button size="small" variant="outlined" onClick={() => { setEditNoteId(null); setEditNoteText(''); }}>
                      Cancel
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <p style={{ margin: 0, flex: 1 }}>{item?.note}</p>
                    {userType === 'Admin' && (
                      <div style={{ display: 'flex', gap: '8px', marginLeft: '12px', flexShrink: 0 }}>
                        <Button
                          size="small"
                          variant="text"
                          style={{ minWidth: 0, padding: '2px 6px', color: '#1976d2' }}
                          onClick={() => { setEditNoteId(item._id); setEditNoteText(item.note); }}
                          title="Edit note"
                        >
                          ✏️
                        </Button>
                        <Button
                          size="small"
                          variant="text"
                          style={{ minWidth: 0, padding: '2px 6px', color: '#d32f2f' }}
                          onClick={() => setDeleteNoteId(item._id)}
                          title="Delete note"
                        >
                          🗑️
                        </Button>
                      </div>
                    )}
                  </div>
                  <time>{moment(item?.createdOn).format('lll')}</time>
                  <p>Updated by <UserName userId={item.createdBy}/></p>
                </>
              )}
            </div>
          ))}
        </div>
        <div className="os-notes-history">
          <h6 className="h6">History</h6>
          {sortLog && sortLog.sort(function (a, b) {
            return new Date(b.createdOn) - new Date(a.createdOn);
          }).map((item) => (
            <div key={item?._id} className="os-notes-history-cnt">
              <p>{item?.message} by <UserName userId={item.createdBy}/></p>
              <time>{moment(item?.createdOn).format('lll')}</time>
              
            </div>))}
        </div>

      </div>
    </div>
  );
}
